import React from 'react';

import { Messages } from '~src/codegen/Localize';
import { imgPath } from '~src/commonInfra/utils/ImgUrl';
import { CardTitle } from '~src/spacesPlatform/components/card/CardTitle';
import { CardViewStyles } from '~src/spacesPlatform/components/card/CardViewStyles';
import { CardPopoverWidget, ContentCard } from '~src/spacesPlatform/components/card/ContentCard';
import { Thumbnail } from '~src/spacesPlatform/components/card/Thumbnail';

import { IContentRelayPlanInfo } from '../models/IContentRelayPlanInfo';

// Centered placeholder icon for the grid (thumbnail) view — mirrors the CloudSyncIcon used in list view.
export const getContentRelayPlanDefaultImageUrl = () => imgPath('content-relay-plan-icon.svg');

export class ContentRelayPlanCard extends ContentCard {
  public render() {
    const { hovered, selected, allowDragAndDrop } = this.props;
    const content = this.props.content as IContentRelayPlanInfo;
    return (
      <div className={CardViewStyles.Card}>
        <Thumbnail
          defaultImageUrl={getContentRelayPlanDefaultImageUrl()}
          hovered={hovered}
          selected={selected}
          allowDragAndDrop={allowDragAndDrop}
          aria-label={content.name}
        />
        <div className={CardViewStyles.ActionRow} style={this.getCardZoomStyleForActionRow()}>
          <CardTitle name={content.name} />
          <span>
            <CardPopoverWidget
              content={content}
              onTriggerClick={this.handleShowPopover}
              popoverContent={this.renderPopoverContent()}
              title={Messages.contentRelayPlanDetails()}
            />
          </span>
          {this.renderActionsMenu()}
        </div>
        {this.shouldRenderExtraInformationAtBottom() && <div className={CardViewStyles.CardDescription}>
          {this.getDescription()}
        </div>}
      </div>
    );
  }
}
